export function isNativeFile(file: any): file is File {
  return file instanceof File;
}
